<template>
    <div id="album-location">
        <div v-if="error" class="container mtb-80">
            <app-back :title="error"></app-back>
        </div>
        <div v-if="albumLocation">
            <app-header :info="albumLocation.location" :title="capitalize(this.title)" :imagePath="albumLocation.location.imagePath" isType="location"></app-header>
            <!-- <p @click="showNow()">Show map</p> -->
            <div v-if="albumLocation.photos" class="rel">
                <div v-if="albumLocation" class="breadcrumbs-parent" style="display:flex; top: 20px; left: 20px">
                    <ul>
                        <li><router-link :to="'/' + album">{{ capitalize(album)}}</router-link></li>
                        <li v-text="capitalize(this.title)"></li>
                    </ul>
                </div>
                <app-pagination :pagination="pagination" @click.native="getResults(pagination.current_page)" :offset="4">
                </app-pagination>
                <app-sb :photos="albumLocation.photos.data" :albumId="album"></app-sb>
                <h3 class="links">
                    <router-link :to="'/galerija/album/' + album">Vse slike </router-link>
                </h3>
            </div>
            <app-google-map :mapName="capitalize(this.title)"></app-google-map>
        </div>
    </div>
</template>

<script>
import { ApiHome, LocationsPhotoUrl } from '../../.env';
import { mapGetters, mapActions } from 'vuex';
import StringsMixin from '../../mixins/StringsMixin';
import HeaderBar from '../../components/layout/HeaderBar.vue';
import GoogleMaps from '../../components/elements/gmaps/GoogleMaps.vue';
import Silentbox from '../../components/elements/silentbox/Silentbox.vue';
import BackButton from '../../components/layout/BackButton.vue';
import Pagination from '../../components/elements/pagination/PaginationPrevent.vue';

export default {
    props: ['location', 'album'],
    mixins: [StringsMixin],

    data() {
        // console.log('album photo template: ', this.location);
        return {
            endpoint: ApiHome+ 'location/' + this.location + '/' + this.album,
            photoUrl: LocationsPhotoUrl,
            photoSize: '1960',
        }
    },

    components: {
        'app-header': HeaderBar,
        'app-google-map': GoogleMaps,
        'app-sb': Silentbox,
        'app-back': BackButton,
        'app-pagination': Pagination,
    },

    computed: {
        ...mapGetters([
            'albumLocation',
            'loading',
            'error',
            'title',
            'paginate',
            'pagination',
        ]),
    },

    methods: {
        /**
         * get paginated results - for page > 1
         */
        getResults(page) {
            console.log('get paginated results: ', page);
            if (typeof page === 'undefined') {
                page = 2;
            }
            let data = {
                endpoint: this.endpoint + '?page=' + page,
                page: page,
                type: 'albumLocation'
            };

            this.$store.dispatch('getPaginatedItems', data);
        },

        fetchLocation() {
            this.$store.dispatch('fetchLocation', this.endpoint);
        },

    },

    created() {
        this.fetchLocation();
        // console.log('location - Component created.', this.albumLocation, this.album, this.location)
    },
}
</script>




// WEBPACK FOOTER //
// src/views/albums/AlbumLocation.vue